/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsDesignListItem,
    MelcoModelsDesignListItemFromJSON,
    MelcoModelsDesignListItemFromJSONTyped,
    MelcoModelsDesignListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsGenericList1MelcoModelsDesignListItem
 */
export interface MelcoModelsGenericList1MelcoModelsDesignListItem {
    /**
     * 
     * @type {Array<MelcoModelsDesignListItem>}
     * @memberof MelcoModelsGenericList1MelcoModelsDesignListItem
     */
    list: Array<MelcoModelsDesignListItem>;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsGenericList1MelcoModelsDesignListItem
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsGenericList1MelcoModelsDesignListItem
     */
    total: number;
}

export function MelcoModelsGenericList1MelcoModelsDesignListItemFromJSON(json: any): MelcoModelsGenericList1MelcoModelsDesignListItem {
    return MelcoModelsGenericList1MelcoModelsDesignListItemFromJSONTyped(json, false);
}

export function MelcoModelsGenericList1MelcoModelsDesignListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsGenericList1MelcoModelsDesignListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(MelcoModelsDesignListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function MelcoModelsGenericList1MelcoModelsDesignListItemToJSON(value?: MelcoModelsGenericList1MelcoModelsDesignListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(MelcoModelsDesignListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


